import React, { useState } from 'react';

const faqs = [
  {
    question: 'Which material is your products made of?',
    answer: 'All of our products are made of 21K gold.',
  },
  {
    question: 'Is the pearls and stones weight included in the price calculation?',
    answer:
      'No, we only calculate the gold weight. Without pearls, stones, and zircons weight.',
  },
  {
    question: 'Do you have a warranty?',
    answer:
      'Our jewelry is covered by a limited warranty of one year from the date of purchase. This warranty covers any manufacturing defects, including issues with the setting, the lock, or the pearls themselves. We will repair or replace any defective items at no cost to you, as long as the damage is not the result of misuse.',
  },
];

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-[#f9f7f4] min-h-screen py-16 px-6 md:px-12 text-[#2A2A2A] font-['Helvetica Neue','Arial','sans-serif']">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-light tracking-widest uppercase text-center mb-12">
          FAQ
        </h1>

        {faqs.map((faq, index) => (
          <div key={index} className="mb-6 border-b pb-4">
            <button
              onClick={() => toggle(index)}
              className="w-full text-left text-lg font-medium hover:text-black transition flex justify-between items-center"
            >
              {faq.question}
              <span className="text-xl">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <p className="mt-3 text-[15px] leading-7 text-gray-700">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
